module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dn-dialog', {
    ref: "dialog",
    attrs: {
      "content-class": "dn-attribute-dialog",
      "btn-close": false,
      "persistent": ""
    },
    on: {
      "before-show": _vm.onBeforeShow
    }
  }, [(_vm.$slots.activator) ? _c('template', {
    slot: "activator"
  }, [_vm._t("activator")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dn-attribute-dialog__header"
  }, [_vm._v("\n\t\tご利用される方は\n\t\t"), _c('br'), _vm._v("どなたですか？\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "dn-attribute-dialog__choices"
  }, [_c('div', {
    staticClass: "dn-attribute-dialog__choices-header"
  }, [_c('span', {
    staticClass: "dn-attribute-dialog__label"
  }, [_vm._v("属性")])]), _vm._v(" "), _vm._l((_vm.columnSets), function(columns, index) {
    return _c('div', {
      key: index,
      staticClass: "dn-attribute-dialog__choices-col"
    }, _vm._l((columns), function(column, index) {
      return _c('label', {
        key: index
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.selected),
          expression: "selected"
        }],
        attrs: {
          "type": "radio",
          "name": "dn-user-attribute"
        },
        domProps: {
          "value": column.id,
          "checked": _vm._q(_vm.selected, column.id)
        },
        on: {
          "change": function($event) {
            _vm.selected = column.id
          }
        }
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(column.label))])])
    }))
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "dn-attribute-dialog__footer"
  }, [_c('p', {
    staticClass: "dn-attribute-dialog__footer-notice"
  }, [_vm._v("※各属性に適した画面が表示されます")]), _vm._v(" "), _c('a', {
    staticClass: "dn-attribute-dialog__btn-apply dn-btn dn-btn--primary dn-btn--text-lg",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v("決定")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73aacf98","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/ui/components/dialogs/AttributeDialog.vue
// module id = 297
// module chunks = 1